<section class="flex flex-col gap-10 max-w-60">
    <app-input-text
        class="grow"
        [inputFormControl]="formGroup!.controls.name"
        [label]="'roleName' | transloco"
        [placeholder]="'roleName' | transloco" />

    <section class="flex flex-col grow gap-2.5">
        <app-input-number
            [inputFormControl]="formGroup!.controls.maxAssignment"
            [label]="'maxAssignments' | transloco"
            [min]="role()?.assignmentCount ?? 1"
            [placeholder]="'unlimited' | transloco"
            (onValueChange)="maxAssignmentChange($event)" />
        <p class="font-normal text-[0.625rem] text-custom-dark-grey">
            {{ 'numberOfRoleAssigned' | transloco }} : {{ role()?.assignmentCount }}
        </p>
    </section>
    <div
        class="flex flex-col gap-10"
        [class.opacity-50]="hasAllPermissions()"
        [class.pointer-events-none]="hasAllPermissions()">
        <section class="flex flex-col grow gap-2.5">
            <div class="flex flex-col gap-0.5 grow">
                <label
                    class="font-normal text-base"
                    data-testid="edit-manage-role-label"
                    >{{ 'manage' | transloco }}</label
                >

                <app-select
                    data-testid="edit-manage-role"
                    [defaultValue]="selectedOptionManage()"
                    [isMultiSelect]="true"
                    [options]="optionsManage()"
                    [placeholder]="'selectPage' | transloco"
                    (optionSelected)="onSelectOptionChange($event, 'MANAGE')" />
            </div>
            <p class="font-normal text-[0.625rem] text-custom-dark-grey">
                {{ 'permission.manageSelectInfo' | transloco }}
            </p>
        </section>

        <section class="flex flex-col grow gap-2.5">
            <div class="flex flex-col gap-0.5 grow">
                <label
                    class="font-normal text-base"
                    data-testid="edit-access-role-label"
                    >{{ 'toAccess' | transloco }}</label
                >

                <app-select
                    data-testid="edit-access-role"
                    [defaultValue]="selectedOptionAccess()"
                    [isMultiSelect]="true"
                    [options]="optionsAccess()"
                    [placeholder]="'selectPage' | transloco"
                    (optionSelected)="onSelectOptionChange($event, 'ACCES')" />
            </div>
            <p class="font-normal text-[0.625rem] text-custom-dark-grey">
                {{ 'permission.accessSelectInfo' | transloco }}
            </p>
        </section>
    </div>

    <div
        class="flex flex-row gap-2 cursor-pointer"
        (click)="changeSelection()">
        <app-checkbox [checkboxState]="hasAllPermissions() ? CheckboxState.CHECKED : CheckboxState.UNCHECKED" />
        {{ 'allPermissions' | transloco }}
        >
    </div>
</section>
